import React from "react";
import { useTranslation } from "react-i18next";

export default function PatientPrintHeaderBox({
  emrData = null,
  patientInfo = null,
  className = "",
}) {
  const { t } = useTranslation();

  const patientName =
    patientInfo?.name ||
    patientInfo?.full_name ||
    emrData?.patient?.full_name ||
    emrData?.patient_name ||
    "---";

  const mrn =
    patientInfo?.mrn ||
    patientInfo?.file_no ||
    emrData?.patient?.file_no ||
    emrData?.patient?.patient_mrn ||
    emrData?.patient_mrn ||
    "---";

  return (
    <div
      className={`hidden print:block mb-2 text-[10px] border border-gray-300 rounded overflow-hidden ${className}`}
    >
      <div className="bg-gray-100 px-2 py-0.5 border-b border-gray-300 font-semibold text-gray-700 flex justify-between items-center text-[10px]">
        <span>{t("Patient Information")}</span>
        <span dir="rtl">معلومات المريض</span>
      </div>
      <div className="grid grid-cols-4 bg-white text-[10px]">
        <div className="p-1 font-semibold border-r border-gray-200 bg-gray-50">
          {t("Patient Name")} / اسم المريض:
        </div>
        <div className="p-1 border-r border-gray-200 font-medium">
          {patientName}
        </div>
        <div className="p-1 font-semibold border-r border-gray-200 bg-gray-50">
          {t("MRN")} / رقم الملف:
        </div>
        <div className="p-1 font-medium">{mrn}</div>
      </div>
    </div>
  );
}
